/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { assistantsDelete } from "../funcs/assistantsDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteAssistantRequest,
  DeleteAssistantSecurity,
} from "../models/operations/deleteassistant.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type AssistantsDeleteMutationVariables = {
  request: DeleteAssistantRequest;
  security?: DeleteAssistantSecurity | undefined;
  options?: RequestOptions;
};

export type AssistantsDeleteMutationData = void;

export type AssistantsDeleteMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteAssistant assistants
 *
 * @remarks
 * Delete an assistant.
 */
export function useAssistantsDeleteMutation(
  options?: MutationHookOptions<
    AssistantsDeleteMutationData,
    AssistantsDeleteMutationError,
    AssistantsDeleteMutationVariables
  >,
): UseMutationResult<
  AssistantsDeleteMutationData,
  AssistantsDeleteMutationError,
  AssistantsDeleteMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildAssistantsDeleteMutation(client, options),
    ...options,
  });
}

export function mutationKeyAssistantsDelete(): MutationKey {
  return ["@gram/client", "assistants", "delete"];
}

export function buildAssistantsDeleteMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: AssistantsDeleteMutationVariables,
  ) => Promise<AssistantsDeleteMutationData>;
} {
  return {
    mutationKey: mutationKeyAssistantsDelete(),
    mutationFn: function assistantsDeleteMutationFn({
      request,
      security,
      options,
    }): Promise<AssistantsDeleteMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(assistantsDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
